import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

/** "Legível" / "Baixo": the banner text contrast, against the 4,5:1 minimum. */
export function ContrastBadge({ readable }: { readable: boolean }) {
  const { LL } = useI18nContext();

  return (
    <span
      data-readable={readable}
      className={cn(
        'flex h-[22px] shrink-0 items-center rounded-full px-[9px] text-[10.5px] font-bold uppercase tracking-[0.12em]',
        readable
          ? 'bg-[#155DFC]/10 text-[#0B4AE0]'
          : 'bg-[#FDECEA] text-[#A8231B]'
      )}
    >
      {readable
        ? LL.couponEditor.studio.readable()
        : LL.couponEditor.studio.low()}
    </span>
  );
}
